import {
  Box,
  Text,
  VStack,
  Badge,
  HStack,
  IconButton,
  Stack,
} from "@chakra-ui/react";
import { useTransactions } from "../context/TransactionsContext";
import { IoCloseSharp } from "react-icons/io5";
import { formatEuro } from "../utils/helperFunctions";
import { useCurrentMonth } from "../hooks/useCurrentMonth";

export const TransactionList = () => {
  const { transactions, removeTransaction } = useTransactions();
  const currentMonth = useCurrentMonth();

  const filteredTransactions = transactions.filter((t) => {
    const date = new Date(t.date);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}` === currentMonth;
  });

  const moneyTypeMap = {
    income: { label: "Einnahmen", color: "green.600", prefix: "+" },
    expense: { label: "Ausgaben", color: "red.500", prefix: "-" },
    saving: { label: "Sparen", color: "#fbb000", prefix: "+" },
  };

  return (
    <Stack style={{ marginBottom: 30, marginTop: 0 }}>
      {filteredTransactions.map((tx) => (
        <>
          <Text
            display="flex"
            justifyContent="flex-end"
            fontSize={"sm"}
            style={{ margin: 0, padding: 0 }}
          >
            {new Date(tx.transactionListDate).toLocaleDateString()}
          </Text>{" "}
          <VStack align="stretch" style={{ margin: 0, paddingBottom: 0 }}>
            <HStack
              key={tx.id}
              justify="space-between"
              p={3}
              gap={"2rem"}
              bg="gray.100"
              borderRadius="md"
              overflow={"auto"}
            >
              <Box>
                <Text
                  maxWidth={150}
                  overflowWrap={"break-word"}
                  fontWeight="medium"
                >
                  {tx.description}
                </Text>
                <Badge
                  color={"white"}
                  px="2"
                  py="0.5"
                  bg={moneyTypeMap[tx.type]?.color || "gray.500"}
                >
                  {moneyTypeMap[tx.type]?.label || "Sonstiges"}
                </Badge>
              </Box>
              <Text fontWeight="bold" color="black">
                {moneyTypeMap[tx.type]?.prefix || ""}
                {formatEuro(tx.amount)}
              </Text>
              <Badge color={"white"} bg={"black"} px="2" py="0.5">
                {tx.category}
              </Badge>
              <IconButton
                size="sm"
                aria-label="Löschen"
                onClick={() => removeTransaction(tx.id)}
                colorScheme="red"
                variant="ghost"
                position={"sticky"}
                right="-13px"
                bg="gray.100"
                zIndex={10}
              >
                {/* @ts-ignore */}
                <IoCloseSharp />
              </IconButton>
            </HStack>
          </VStack>
        </>
      ))}
    </Stack>
  );
};
